"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelBody = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _getScrollbarWidth = require("../../../util/getScrollbarWidth");
var _StyledPanelBodyComponents = require("../styled/StyledPanelBodyComponents");
/**
 *  allow for ScrollArea customizations but enforce fullwidth keylines & let spacing be controlled via padding overrides
 */

/**
 * The body/content area of a Panel with built in scroll area configurations.
 *
 * Notes:
 * * Built on top of ScrollArea component, and most ScrollArea props are available to pass through
 * * Exposes css variables to control padding
 */
const PanelBody = _ref => {
  let {
    children,
    clientId,
    showKeyLines = "both",
    includeScrollingIndication = false,
    ...otherProps
  } = _ref;
  const [scrollbarWidth] = (0, _react.useState)((0, _getScrollbarWidth.getScrollBarWidth)());
  return /*#__PURE__*/_react.default.createElement(_StyledPanelBodyComponents.StyledPanelBodyWrapper, (0, _extends2.default)({
    clientId: `panel-body${clientId ? `-${clientId}` : ""}`,
    showKeyLines: showKeyLines,
    includeScrollingIndication: includeScrollingIndication,
    showFullWidthKeylines: true,
    gutter: "none"
  }, otherProps), /*#__PURE__*/_react.default.createElement(_StyledPanelBodyComponents.StyledInnerWrapper, {
    scrollbarWidth: scrollbarWidth
  }, children));
};
exports.PanelBody = PanelBody;
//# sourceMappingURL=PanelBody.js.map